import {FormFA, OrganizationFA, ProjectFA, Submission, UserInterface} from "../interfaces/global-interfaces";
import {api} from "./api";

export const getProjects = async (organization: string) => {
    const response = await api.get(`/${organization}/projects`);
    return response.data as ProjectFA[];
};

export const getOrganizations = async () => {
    const response = await api.get(`/organizations`);
    return response.data as OrganizationFA[];
};

export const createOrganization = async (data: { name: string; description?: string }) => {
    try {
        const response = await api.post(`/organizations`, data);
        return response.data as { message: string; organization: OrganizationFA };
    } catch (error: any) {
        console.error('Error creating organization:', error);
        throw error.response?.data || {message: 'Unknown error'};
    }
};

export const updateOrganization = async (organizationId: string, data: { name?: string; description?: string }) => {
    try {
        const response = await api.patch(`/organizations/${organizationId}`, data);
        return response.data as { message: string; organization: OrganizationFA };
    } catch (error: any) {
        console.error(`Error updating organization ${organizationId}:`, error);
        throw error.response?.data || {message: 'Unknown error'};
    }
};

export const deleteOrganization = async (organizationId: string) => {
    try {
        const response = await api.delete(`/organizations/${organizationId}`);
        return response.data as { message: string };
    } catch (error: any) {
        console.error(`Error deleting organization ${organizationId}:`, error);
        throw error.response?.data || {message: 'Unknown error'};
    }
};

export const getProjectById = async (projectId: string) => {
    const response = await api.get(`/projects/${projectId}`);
    return response.data;
};

export const patchProject = async (projectId: string, data: any) => {
    const response = await api.patch(`/projects/${projectId}`, data);
    return response.data as ProjectFA;
};

export const createProject = async (projectData: any) => {
    const response = await api.post('/projects', projectData);
    return response.data as ProjectFA;
};

export const getFormsByProjectId = async (projectId: string) => {
    const response = await api.get(`/projects/${projectId}/forms`);
    return response.data as FormFA[]
};

export const getFormById = async (projectId: string, formId: string) => {
    const response = await api.get(`/projects/${projectId}/forms/${formId}`);
    return response.data as any;
};

export const getUserMe = async () => {
    const response = await api.get(`/me`);
    return response.data as UserInterface
}

export const createForm = async (projectId: string, formData: FormFA) => {
    const response = await api.post(`/projects/${projectId}/forms`, formData);
    return response.data as FormFA;
};

export const deleteProject = async (projectId: string) => {
    try {
        const response = await api.delete(`/projects/${projectId}`);
        return response.data;
    } catch (error: any) {
        console.error(`Error deleting project ${projectId}:`, error);
        throw error.response?.data || {message: 'Unknown error'};
    }
};

export const deleteForm = async (projectId: string, formId: string) => {
    try {
        const response = await api.delete(`/projects/${projectId}/forms/${formId}`);
        return response.data;
    } catch (error: any) {
        console.error(`Error deleting form ${formId} in project ${projectId}:`, error);
        throw error.response?.data || {message: 'Unknown error'};
    }
};

export const patchForm = async (
    projectId: string,
    formId: string,
    formData: Partial<FormFA>
) => {
    const response = await api.patch(
        `/projects/${projectId}/forms/${formId}`,
        formData
    );
    return response.data as FormFA;
};


export const submitForm = async (
    projectId: string,
    formId: string,
    payload: any
) => {
    const response = await api.post(
        `/projects/${projectId}/forms/${formId}/submissions`,
        payload
    );
    return response.data;
};

export const getSubmissionsByFormId = async (formId: string, page: number = 1) => {
    try {
        const response = await api.get(`/forms/${formId}/submissions`, {
            params: {page},
        });
        return response.data as Submission[];
    } catch (error: any) {
        console.error('Error fetching submissions:', error);
        throw error.response?.data || {message: 'Unknown error'};
    }
};

export const get_user_by_id = async (user_id: string) => {
    const response = await api.get(`/users/${user_id}`);
    return response.data as UserInterface
}

export const create_user = async (name: string, surname: string, email: string, organization: string) => {
    const response = await api.post(`/organizations/${organization}/add-user`, {name, surname, email});
    return response.data as OrganizationFA
}

export const remove_user = async (organization_id: string, user_id: string) => {
    const response = await api.patch(`/organizations/${organization_id}/remove-user/${user_id}`);
    return response.data
}
